import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { Bid, BidItem, BidWorksheet } from '@app/models';

export interface BidDetail extends Bid {
  items: BidItem[];
  worksheets: BidWorksheet[];
}

@Injectable({
  providedIn: 'root',
})
export class BidService {
  constructor(private http: HttpClient, private api: ApiService) {}

  getBid(id: string): Observable<BidDetail> {
    return this.http.get<BidDetail>(`${this.api.url}/bids/${id}`);
  }

  createBid(): Observable<Bid> {
    return this.http.post<Bid>(`${this.api.url}/bids`, {});
  }

  createWorksheet(bidId: string, total: number): Observable<BidWorksheet> {
    return this.http.post<BidWorksheet>(
      `${this.api.url}/bids/${bidId}/worksheets`,
      { total }
    );
  }

  getWorksheet(id: string): Observable<BidWorksheet> {
    return this.http.get<BidWorksheet>(`${this.api.url}/bids/worksheets/${id}`);
  }

  markUploaded(id: string): Observable<BidWorksheet> {
    return this.http.patch<BidWorksheet>(
      `${this.api.url}/bids/worksheets/${id}`,
      { fileExists: true }
    );
  }

  fileUrl(id: string): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(
      `${this.api.url}/bids/worksheets/${id}/file`
    );
  }

  addToJob(id: string): Observable<BidWorksheet> {
    return this.http.post<BidWorksheet>(
      `${this.api.url}/bids/worksheets/${id}/add-to-job`,
      {}
    );
  }

  /** Straight to S3 with fetch: the API interceptor must not add auth or re-case anything. */
  async uploadPdf(uploadUrl: string, bytes: Uint8Array): Promise<void> {
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/pdf' },
      body: new Blob([bytes], { type: 'application/pdf' }),
    });
    if (!response.ok) {
      throw new Error(`Upload failed (${response.status}).`);
    }
  }
}
